<template>
  <div class="onboarding-signup-step-check">
    <form @submit.prevent="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title-optional">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.CHECK.@TITLE")) }}
          </h2>

          <section>
            <span class="q-mx-md">
              {{ $t("ETAB.PAGES.SIGNUP.STEPS.MAIN.CHECK.@YES") }}
            </span>
            <span class="q-mx-sm">
              {{ $t("ETAB.PAGES.SIGNUP.STEPS.MAIN.CHECK.@NO") }}
            </span>
          </section>

          <section>
            <label>
              {{ $t("ETAB.PAGES.SIGNUP.STEPS.MAIN.CHECK.@LARGE") }}
            </label>
            <div>
              <QRadio v-model="form.isLarge" size="lg" :val="true" />
              <QRadio v-model="form.isLarge" size="lg" :val="false" />
            </div>
          </section>
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn
            color="secondary"
            type="submit"
            class="full-width btn-navigation"
            :label="$t('ETAB.BUTTONS.@NEXT')"
            no-caps
            :disable="disabledNextButton"
          />
        </div>
      </QFooter>
    </form>
  </div>
</template>

<script setup>
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { ETAB, FIREBASE_EVENTS } from "@core/constants";
  import { FUNNEL_SIGNUP_MAIN } from "@etab/config";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { PosthogManager } from "@etab/managers/posthog.manager";
  import { reactive, computed, onMounted } from "vue";
  import { ISignup } from "@core/models";
  import { useTransition } from "@core/composables";
  import { useSignup } from "@etab/composables";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const form = reactive({ isLarge: undefined });

  const disabledNextButton = computed(() => {
    return form.isLarge === undefined;
  });
  const isHotelGC = computed(() => {
    return signupStore[GETTER_SIGNUP_GET][ISignup.segment] === ETAB.SEGMENT.HOTEL_GC;
  });
  const isHotel = computed(() => {
    return signupStore[GETTER_SIGNUP_GET][ISignup.segment] === ETAB.SEGMENT.HOTEL;
  });

  const onSubmit = function () {
    const data = {
      [ISignup.isLarge]: form.isLarge,
    };

    if (form.isLarge) {
      // Définit le segment à "GRAND_COMPTE" par défaut, sauf si le segment actuel est "HOTEL" ou "HOTEL_GC"
      data[ISignup.segment] = isHotel.value || isHotelGC.value ? ETAB.SEGMENT.HOTEL_GC : ETAB.SEGMENT.GRAND_COMPTE;
    } else {
      // Définit le segment à "CHR" par défaut, sauf si le segment actuel est "HOTEL"
      data[ISignup.segment] = isHotel.value ? ETAB.SEGMENT.HOTEL : ETAB.SEGMENT.CHR;
    }
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step7_1_size--optional",
    });
    signupStore[ACTION_SIGNUP_UPDATE](data);
    PosthogManager.captureEvent("sign_up", { $step: FUNNEL_SIGNUP_MAIN.check, $is_optionnal: true, $step_position: 4.1 });
    $_nextStep();
  };

  onMounted(() => {
    form.isLarge = signupStore[GETTER_SIGNUP_GET][ISignup.isLarge];
  });
</script>

<style lang="scss">
  .onboarding-signup-step-check {
    .q-page section {
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      > label {
        flex: 1;
        padding-right: 15px;
      }
      > div {
        width: 105px;
      }
    }
  }
</style>
